export const ALERT_TEST_IDS = {
  PAGE: 'alert-page',
  SEARCH_INPUT: 'alert-search-input',
  FILTER_DROPDOWN: 'alert-filter-dropdown',
  TYPE_FILTER: 'alert-type-filter',
  LEVEL_FILTER: 'alert-level-filter',
  STATUS_FILTER: 'alert-status-filter',
  TABLE: 'alert-table',
  TABLE_ROW: (id: string) => `alert-table-row-${id}`,
  COL_ALERT_ID: (id: string) => `alert-col-alert-id-${id}`,
  COL_OPERATOR_ID: (id: string) => `alert-col-operator-id-${id}`,
  COL_MARKET_ID: (id: string) => `alert-col-market-id-${id}`,
  COL_DEVICE_ID: (id: string) => `alert-col-device-id-${id}`,
  COL_TYPE: (id: string) => `alert-col-type-${id}`,
  COL_STATUS_CODE: (id: string) => `alert-col-status-code-${id}`,
  COL_LEVEL: (id: string) => `alert-col-level-${id}`,
  COL_STATUS: (id: string) => `alert-col-status-${id}`,
  COL_TRIGGERED_ON: (id: string) => `alert-col-triggered-on-${id}`,
  COL_CLOSED_ON: (id: string) => `alert-col-closed-on-${id}`,

  // ── Expanded row panel ───────────────────────────────────────────────
  EXPANDED_PANEL: 'alert-expanded-panel',
  EXPANDED_HEADER: 'alert-expanded-header',
  EXPANDED_TIMING: 'alert-expanded-timing',
  EXPANDED_FLOW: 'alert-expanded-flow',
  EXPANDED_MORE_TOGGLE: 'alert-expanded-more-toggle',
  EXPANDED_MORE_CONTENT: 'alert-expanded-more-content',
  EXPANDED_TIMELINE: 'alert-expanded-timeline',

  // ── Activity flow stepper ────────────────────────────────────────────
  STEPPER_STEP: (label: string) => `alert-stepper-step-${label?.toLowerCase()}`,
  STEPPER_DURATION_TO: (label: string) =>
    `alert-stepper-duration-to-step-${label?.toLowerCase()}`,
  STEPPER_LABEL: (label: string) =>
    `alert-stepper-label-${label?.toLowerCase()}-step`,
  STEPPER_TIMESTAMP: (label: string) =>
    `alert-stepper-timestamp-${label?.toLowerCase()}`,
  STEPPER_DURATION_VALUE: (label: string) =>
    `alert-stepper-elapsed-time-value-${label?.toLowerCase()}`,
} as const;
